import type { ProductUnit } from "../api/products";

export function servingLabel(u: ProductUnit): { amount: number; label: string } {
  if (u === "piece") return { amount: 1, label: "шт" };
  if (u === "ml") return { amount: 100, label: "мл" };
  return { amount: 100, label: "г" };
}

export function unitLabel(u: ProductUnit): string {
  if (u === "piece") return "шт";
  if (u === "ml") return "мл";
  return "г";
}

export function unitInputLabel(u: ProductUnit): string {
  if (u === "piece") return "Штук";
  if (u === "ml") return "Миллилитры";
  return "Граммы";
}
